export default __webpack_public_path__ + "static/media/pos-pro-21.9df59259.jpg";